const folderRoute = "/folders";
const aFolderRoute = (folderId: number) => `${folderRoute}/${folderId}`;
const moveGameToFolderRoute = (gameId: number) => `/games/${gameId}/folder`;

const gameRoute = "/games";
const aGameRoute = (gameId: number | string) => `${gameRoute}/${gameId}`;
const gamePositionsRoute = `${gameRoute}/positions`;
const renameGameRoute = (gameId: number) => `${gameRoute}/${gameId}/rename`;
const changeGameDateRoute = (gameId: number) => `${gameRoute}/${gameId}/date`;
const changeGameWeekRoute = (gameId: number) => `${gameRoute}/${gameId}/week`;
const latestGameRoute = `${gameRoute}?limit=1&order=desc`;

const playRoute = "/plays";
const aPlayRoute = (playId: number | string) => `${playRoute}/${playId}`;

const settingsRoute = "/settings";

export default {
  folderRoute,
  aFolderRoute,
  moveGameToFolderRoute,
  gameRoute,
  aGameRoute,
  gamePositionsRoute,
  renameGameRoute,
  changeGameDateRoute,
  changeGameWeekRoute,
  latestGameRoute,
  playRoute,
  aPlayRoute,
  settingsRoute,
};
